import React, { useState, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { ROUTES } from '../constants/routes';

function ChangePassword() {
  const { user, token, login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword !== confirmPassword) {
      setError('New passwords do not match.');
      return;
    }
    if (newPassword.length < 12) {
      setError('New password must be at least 12 characters.');
      return;
    }
    setBusy(true);
    try {
      const res = await axios.post(
        '/api/auth/change-password',
        { currentPassword, newPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      login(res.data.user, res.data.token);
      navigate(ROUTES.HOME, { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || err.response?.data?.message || 'Could not change password');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center py-5 px-3 app-login-shell">
      <div className="container app-login-panel mx-auto">
        <div className="text-center mb-4">
          <h1 className="h4 fw-semibold mb-1">Change your password</h1>
          <p className="text-muted small mb-0">
            {user?.name ? `Signed in as ${user.name}` : 'A new password is required before you can continue.'}
          </p>
        </div>
        <div className="card app-card border-0 shadow-lg">
          <div className="card-body p-4 p-md-5">
            <div className="alert alert-info small mb-4">
              Your password was set by an administrator. Choose a new password to continue.
            </div>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label" htmlFor="current-password">
                  Current password
                </label>
                <input
                  id="current-password"
                  type="password"
                  className="form-control"
                  autoComplete="current-password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  required
                />
                <div className="form-text">Use the temporary password you were given.</div>
              </div>
              <div className="mb-3">
                <label className="form-label" htmlFor="new-password">
                  New password
                </label>
                <input
                  id="new-password"
                  type="password"
                  className="form-control"
                  autoComplete="new-password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  minLength={12}
                  required
                />
              </div>
              <div className="mb-4">
                <label className="form-label" htmlFor="confirm-password">
                  Confirm new password
                </label>
                <input
                  id="confirm-password"
                  type="password"
                  className="form-control"
                  autoComplete="new-password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  minLength={12}
                  required
                />
              </div>
              {error && <div className="alert alert-danger">{error}</div>}
              <button type="submit" className="btn btn-primary w-100 py-2" disabled={busy}>
                {busy ? 'Saving…' : 'Save and continue'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
